export default `vec3 transformed = vec3(position);
if (aPacked.w > 0.5) {
    transformed += faceNormal * 0.08;
}`